import Vue, { ComponentOptions } from "vue";
import Vuex from "vuex";

import size from "lodash-es/size";

import "./panel-search.css";

Vue.use(Vuex);

interface PanelSearch extends Vue {
    initialAction: string;
    urlBuy: string;
    urlRent: string;
    view: HTMLElement | null;
    action: string;
    isOpen: boolean;
    classActions: () => object;
    zipOrPlace: string;
    type: string;
    objectTitle: string;
    roomsFrom: number;
    roomsTo: number;
    priceFrom: number;
    priceTo: number;
    objectName: string;
    setAction: (action: string ) => void;
    toggleOpen: () => void;
    resizeInner: () => void;
}

const PanelSearch = {
    props: ["initialAction", "urlBuy", "urlRent"],
    data() {
        return {
            view: null,
            action: this.initialAction,
            isOpen: false,
        };
    },
    computed: {
        classActions() {
            return {
                "js-rent": this.isOpen && this.action === "rent",
                "js-buy": this.isOpen && this.action === "buy",
            };
        },
        zipOrPlace: {
            get(this: PanelSearch) { return this.$store.state.search.zipOrPlace; },
            set(this: PanelSearch, value) { this.$store.commit("updateSearch", { content: { what: "zipOrPlace", value }, action: this.action }); },
        },
        type: {
            get(this: PanelSearch) { return this.$store.state.search.type; },
            set(this: PanelSearch, value) { this.$store.commit("updateSearch", { content: { what: "type", value }, action: this.action }); },
        },
        roomsFrom: {
            get(this: PanelSearch) { return this.$store.state.search.roomsFrom; },
            set(this: PanelSearch, value) { this.$store.commit("updateSearch", { content: { what: "roomsFrom", value }, action: this.action }); },
        },
        roomsTo: {
            get(this: PanelSearch) { return this.$store.state.search.roomsTo; },
            set(this: PanelSearch, value) { this.$store.commit("updateSearch", { content: { what: "roomsTo", value }, action: this.action }); },
        },
        priceFrom: {
            get(this: PanelSearch) { return this.$store.state.search.priceFrom; },
            set(this: PanelSearch, value) { this.$store.commit("updateSearch", { content: { what: "priceFrom", value }, action: this.action }); },
        },
        priceTo: {
            get(this: PanelSearch) { return this.$store.state.search.priceTo; },
            set(this: PanelSearch, value) { this.$store.commit("updateSearch", { content: { what: "priceTo", value }, action: this.action }); },
        },
        objectName: {
            get(this: PanelSearch) { return window.location.href.indexOf("liegenschaften") !== -1 ? this.$store.state.details.name : this.$store.state.details.name; },
        },
        objectTitle: {
            get(this: PanelSearch) { return window.location.href.indexOf("liegenschaften") !== -1 ? this.$store.state.details.objectTitle : this.$store.state.details.objectTitle; },
        },
    },
    mounted(this: PanelSearch) {
        this.view = document.querySelector("#view") as HTMLElement;

        // launch the first search, if not already is a route, handled by router-redirect
        // const currentRoute = router.currentRoute;
        //
        // if (!currentRoute.name) {
        //     this.$store.commit("resetSearch");
        //     router.push(this.urlRent + '/rents')
        // }
    },
    methods: {
        setAction(action: string) {
            this.isOpen = !this.isOpen || !(this.action === action && this.isOpen);
            this.action = action;

            this.$store.commit("resetSearch");

            if (this.view) {
                if (this.isOpen) { this.view.classList.add("is-not-sm-scrollable2"); }
                else { this.view.classList.remove("is-not-sm-scrollable"); }
            }
        },
        toggleOpen() {
            this.isOpen = !this.isOpen;
        },
        doSearch() {
            switch (this.action) {
                case "rent":
                    if (size(this.urlRent) > 0) { window.location.assign(this.urlRent + "#/rents"); }
                    break;
            }
        },
    },
} as ComponentOptions<PanelSearch>;

export { PanelSearch };



// WEBPACK FOOTER //
// ./src/components/panel-search.ts